export type StatusApuracao = 0 | 1 | 2; // Aberta | Fechada | Reaberta
export type RegimePisCofins = 1 | 2;     // Cumulativo | NaoCumulativo
export type RegimeIrpj = 1 | 2 | 3;       // SimplesNacional | Presumido | Real
export type PeriodicidadeIrpj = 1 | 2;    // Mensal | Trimestral

export type TipoApuracao = "icms" | "pis-cofins" | "irpj-csll";

export const STATUS_LABEL: Record<StatusApuracao, string> = {
  0: "Aberta",
  1: "Fechada",
  2: "Reaberta",
};

export const REGIME_PIS_COFINS_LABEL: Record<RegimePisCofins, string> = {
  1: "Cumulativo",
  2: "Não-Cumulativo",
};

export const REGIME_IRPJ_LABEL: Record<RegimeIrpj, string> = {
  1: "Simples Nacional",
  2: "Lucro Presumido",
  3: "Lucro Real",
};

export interface ApuracaoIcms {
  id: number;
  empresaId: number;
  periodo: string;
  dtInicio: string;
  dtFim: string;
  debitosSaidas: number;
  creditosEntradas: number;
  icmsST: number;
  difal: number;
  fcp: number;
  saldoAnterior: number;
  saldoApurar: number;
  qtdNotasSaida: number;
  qtdNotasEntrada: number;
  status: StatusApuracao;
  dtCalculo?: string | null;
  dtFechamento?: string | null;
  dtReabertura?: string | null;
  precisaRecalculo: boolean;
  observacoes?: string | null;
}

export interface ApuracaoPisCofins {
  id: number;
  empresaId: number;
  periodo: string;
  dtInicio: string;
  dtFim: string;
  regime: RegimePisCofins;
  receitaBruta: number;
  basePis: number;
  aliqPis: number;
  valorPis: number;
  creditoPis: number;
  pisApurar: number;
  baseCofins: number;
  aliqCofins: number;
  valorCofins: number;
  creditoCofins: number;
  cofinsApurar: number;
  qtdNotas: number;
  status: StatusApuracao;
  dtCalculo?: string | null;
  dtFechamento?: string | null;
  dtReabertura?: string | null;
  precisaRecalculo: boolean;
  observacoes?: string | null;
}

export interface ApuracaoIrpjCsll {
  id: number;
  empresaId: number;
  periodo: string;
  dtInicio: string;
  dtFim: string;
  regime: RegimeIrpj;
  periodicidade: PeriodicidadeIrpj;
  receitaBruta: number;
  basePresuncaoIrpj: number;
  percPresuncaoIrpj: number;
  baseCalculoIrpj: number;
  valorIrpj: number;
  adicionalIrpj: number;
  irpjApurar: number;
  basePresuncaoCsll: number;
  percPresuncaoCsll: number;
  baseCalculoCsll: number;
  valorCsll: number;
  csllApurar: number;
  qtdNotas: number;
  status: StatusApuracao;
  dtCalculo?: string | null;
  dtFechamento?: string | null;
  dtReabertura?: string | null;
  precisaRecalculo: boolean;
  observacoes?: string | null;
}

export interface ApuracaoDetalheNota {
  notaEletronicaId: number;
  numeroNota: number;
  serie?: string | null;
  chaveNota?: string | null;
  cfop?: string | null;
  dtEmissao: string;
  nomeRazao?: string | null;
  valorTotal: number;
  baseIcms: number;
  valorIcms: number;
  basePisCofins: number;
  valorPis: number;
  valorCofins: number;
  isEntrada: boolean;
  isCancelado: boolean;
}

export interface ApuracaoDetalhe {
  apuracaoId: number;
  periodo: string;
  tipo: string;
  totalNotas: number;
  totalDebito: number;
  totalCredito: number;
  notas: ApuracaoDetalheNota[];
}

export interface ApuracaoAjuste {
  id: number;
  tipoApuracao: number;
  apuracaoId: number;
  tributo: string | null;
  valor: number;
  descricao: string | null;
  dtCriacao: string;
}
